import I18nProvider from '@rc-d2c/i18n/provider';
import { type QueryClient } from '@tanstack/query-core';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import React, { PropsWithChildren } from 'react';

import useNotifications from '../hooks/useNotifications';
import { RoutingProvider } from '../hooks/useRouting';
import { RoutingProps } from '../routing.type';

export type ProvidersHOCProps = PropsWithChildren<{
  withI18n?: boolean;
  withRouting?: RoutingProps;
  withQueryClient?: { client: QueryClient };
  withNotifications?: boolean;
}>;

export function ProvidersHOC({ children, withI18n, withRouting, withQueryClient, withNotifications }: ProvidersHOCProps) {
  let wrappedComponent = children;
  const { renderNotifications } = useNotifications();

  if (withI18n) {
    wrappedComponent = <I18nProvider>{wrappedComponent}</I18nProvider>;
  }
  if (withRouting) {
    wrappedComponent = <RoutingProvider {...withRouting}>{wrappedComponent}</RoutingProvider>;
  }
  if (withQueryClient) {
    wrappedComponent = (
      <QueryClientProvider {...withQueryClient}>
        <div>
          {withNotifications && renderNotifications()}
          {wrappedComponent}
          <ReactQueryDevtools initialIsOpen={false} />
        </div>
      </QueryClientProvider>
    );
  }

  return <>{wrappedComponent}</>;
}
